<script>
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import rpc from '@/odoorpc'
import MaterialDetails from '@components/material-details.vue'

/**
 * 物料库存
 */
export default {
  page: {
    title: '备料管理',
    meta: [{
      name: 'description',
      content: appConfig.description
    }],
  },
  components: {
    Layout,
    MaterialDetails
  },

  data() {
    return {
      // 显示搜索条件
      showSearch: true,

      maxHeight: '328px',
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 0,
        pageSize: 10,
      },
      searchParams:{
            //   型号
        searchData: '',
        //   编码
        searchCode:'',
      },
    
      // 物料类型
      productionType:'',

      pageshow: false,

      paginationData: {   // 分页信息
        // 总数据条数
        total: 0,
        // 当前页
        currentPage: 1,
        // 每页展示几条数据
        page_Size: 10,
      },

      allData: [],  // 全部表格数据
      tableData: [],  // 当前页表格数据，这个绑定给el-table

      options: [{
        value: '选项1',
        label: '新建'
      }, {
        value: '选项2',
        label: '报价'
      }, {
        value: '选项3',
        label: '评审'
      }, {
        value: '选项4',
        label: '确认'
      }, {
        value: '选项5',
        label: '执行'
      }],

    }
  },
  created() {
    this.getData()
  },
  methods: {
    select(){
      this.getData()
    },
    getData() {
      rpc.web.dataset.call_kw({
        model: 'product.encoding',
        method: 'search_partner_product',
        args: [],
        kwargs: {
          "currentPage": this.paginationData.currentPage,
          "pageSize": this.paginationData.page_Size,
          "searchData": this.searchParams.searchData,
          "searchCode": this.searchParams.searchCode,
        }
      })
          .then(res => {
            this.tableData = res.data
            this.paginationData.total = res.total

          })
    },
    handlePageSize(pageSize) {
      this.paginationData.page_Size = pageSize
      // 这里写获取的的方法
      this.getData()

    },
    handlePageChange(pageNum) {
      this.paginationData.currentPage = pageNum
      // 这里写获取的的方法
      this.getData()
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.searchParams.searchData = ""
      this.searchParams.searchCode = ""
      this.paginationData.currentPage = 1
      this.productionType = ""
      this.getData()
    },


    search() {
      if (!this.searchParams.searchData || !this.searchParams.searchCode) {
        this.paginationData.currentPage = 1
      }
      this.getData()
    },

  }
}

</script>

<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">备料管理</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body p-0">
            <el-form :model="searchParams" :inline="true" class="p-3">
                <el-form-item label="编码" prop="searchCode">
                    <el-input v-model="searchParams.searchCode"
                            placeholder="请输入：编码"
                            clearable size="small"
                            style="width: 240px"
                            @keyup.enter.native="search">
                    </el-input>
                </el-form-item>

                 <el-form-item label="物料型号" prop="searchData">
                    <el-input v-model="searchParams.searchData" 
                        placeholder="请输入：物料型号"
                        clearable size="small"
                        style="width: 240px"
                        @keyup.enter.native="search">
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
                    <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>
            


            <div style="margin-top: -0.6rem;">
              <el-table :data="tableData" :pager="true" :page-size="80" style="width: 100%" stripe
                        class="p-3">
                <el-table-column type="selection" width="55" align="center"/>
                <el-table-column prop="encoding_name" label="编码"/>
                <el-table-column prop="bom_name" label="物料名称"/>
                <el-table-column prop="product_name" label="型号"/>
                <el-table-column prop="product_qty" label="库存数量"/>
                <el-table-column prop="available_quantity" label="可用数量"/>

                
                <el-table-column label="查看明细">
                  <template slot-scope="scope">
                    <MaterialDetails :product_id='scope.row.product_id'/>
                  </template>
                </el-table-column>

              </el-table>


              <el-pagination
                  background
                  style="margin-top: 20px; text-align: right;"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="paginationData.total"
                  :current-page="paginationData.currentPage"
                  :page-size="paginationData.page_Size"
                  :page-sizes="[10, 30, 50]"
                  @size-change="handlePageSize"
                  @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.el-form-item__label {
  color: #6c757d;
}

.el-form-item {
  margin-bottom: 0rem;
}

.el-input__inner {
  border-radius: 0;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  height: 1.25rem;
}

</style>
